import * as React from "react";
import { useRouter } from "next/router";
import { cx } from "@nju/css";
import { useOffer, useOfferMode } from "@nju/data-access-portal-offers";
import { portalRoutes } from "@nju/routes";
import { BlockText, Heading } from "@nju/ui";
import { RegistrationForm } from "./RegistrationForm";

interface IRegistrationPageProps {
  offerId: string | undefined;
}

export function RegistrationPage({ offerId }: IRegistrationPageProps) {
  const router = useRouter();
  const mode = useOfferMode();
  const hasOffer = portalRoutes.zalozKonto.hasParam(router.query, "oferta");
  const offer = useOffer(offerId);

  React.useLayoutEffect(() => {
    if (mode === "ftth" && offer?.state === "ARCHIVED") {
      router.push(portalRoutes.swiatlowod.get());
    }
  }, [mode, offer?.state, router]);

  return (
    <div
      className={cx("from-tablet:flex from-tablet:justify-center", {
        "from-tablet:block": hasOffer,
        "from-tablet:justify-start": hasOffer,
      })}
    >
      <div
        className={cx("from-tablet:inline-flex flex-col", {
          "from-tablet:flex": hasOffer,
        })}
      >
        <Heading
          className="mb-2 from-tablet:mb-4"
          font="ttfirs"
          tone="neutral"
          variant="h2"
          weight="bold"
        >
          załóż nowe konto nju
        </Heading>
        <BlockText size={{ "@onlyMobile": "s", "@fromTablet": "m" }}>
          <div className="flex items-center gap-3">
            Uwaga: to nie jest konto dla usług nju na kartę lub nju abonament.
          </div>
          <div className="flex items-center gap-3">
            To konto użytkownika wyłącznie dla usług nju z subskrypcją (nju
            subskrypcja i nju światłowód).
          </div>
        </BlockText>
        <RegistrationForm />
      </div>
    </div>
  );
}
